import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraSoftwareName: {
		id: 'project-create-importer-upload-flow.common.constants.source-items.jira-software-name',
		defaultMessage: 'Jira (software project)',
		description: 'Name for jira Software project',
	},
	jiraBusinessNameNonFinal: {
		id: 'project-create-importer-upload-flow.common.constants.source-items.jira-business-name-non-final',
		defaultMessage: 'Jira (business project)',
		description: 'Name for jira business project',
	},
	jiraSoftware: {
		id: 'project-create-importer-upload-flow.common.constants.source-items.jira-software',
		defaultMessage: 'Software project',
		description: 'Label for jira Software project',
	},
	jiraSoftwareDescription: {
		id: 'project-create-importer-upload-flow.common.constants.source-items.jira-software-description',
		defaultMessage: 'Designed to plan, track, release, and support software development.',
		description: 'Description for jira Software project',
	},
	jiraBusiness: {
		id: 'project-create-importer-upload-flow.common.constants.source-items.jira-business',
		defaultMessage: 'Business project',
		description: 'Label for jira Business project',
	},
	jiraBusinessDescription: {
		id: 'project-create-importer-upload-flow.common.constants.source-items.jira-business-description',
		defaultMessage:
			'Designed for business teams across marketing, operations, sales, HR, finance, legal, and design.',
		description: 'Description for jira Business project',
	},
});
